<template>
  <div class="fs-background fs-background--fullscreen">
    <div class="form-container form-container--floating">
      <div class="logo logo--wcz" />
      <v-form
        ref="form"
        v-model="valid"
        lazy-validation
      >
        <v-text-field
          v-model="email"
          solo
          validate-on-blur
          :rules="emailRules"
          prepend-icon="fa-envelope"
          v-bind:disabled="isAuthenticating"
          :label="$t('forms.email')"
        ></v-text-field>

        <v-text-field
          v-model="pchn"
          solo
          validate-on-blur
          prepend-icon="fa-home"
          type="text"
          v-bind:disabled="isAuthenticating"
          :label="$t('forms.pchn')"
        ></v-text-field>
      </v-form>
      <div>
        <v-btn
          @click="signIn"
          v-bind:loading="isAuthenticating"
          color="primary"
          v-bind:disabled="isAuthenticating || !valid"
          v-t="'buttons.login'"
        >
        </v-btn>
      </div>
      <v-alert
        :value="error"
        type="error"
        outline
      >
        <msp-api-error :response="error" />
      </v-alert>
    </div>
  </div>
</template>

<script>

export default {
  data() {
    return {
      valid: false,
      showPassword: false,
      email: '',
      error: null,
      pchn: '',
      emailRules: [
        v => !v || /.+@.+/.test(v) || 'Voer een geldig e-mailadres in',
      ],
    };
  },

  computed: {
    isAuthenticating() { return this.$store.state.account.isAuthenticating; },
  },

  mounted() {
    this.error = null;
  },

  methods: {
    async signIn() {
      this.error = null;
      try {
        await this.$store.dispatch('account/signInAs', { email: this.email, pchn: this.pchn });
        this.$router.replace('dashboard');
      } catch (error) {
        this.error = error;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.logo--wcz {
  position: absolute;
  top: -64px;
  height: 100px;
  width: 300px;
}
</style>
